import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import ListGroup from 'react-bootstrap/ListGroup';

const Queofrecemos = () => {
  return (
    <>
      {/* Título fuera del contenedor */}
      <div className="container my-5">
        <h3 className="text-center text-danger mb-4">SUMINISTROS Y SERVICIOS</h3>
        <div className="d-flex justify-content-center">
          <Container className="p-4 text-white rounded shadow-sm">
            <h5 className="text-center mb-3 titulo-rojo">Sistemas contra incendio normalizados o certificados UL/FM</h5>
            <Row>
              <ListGroup variant="flush">
                <ListGroup.Item className="bg-transparent text-white border-0">• Sistema de elevación Tanque bajo - Tanque alto</ListGroup.Item>
                <ListGroup.Item className="bg-transparent text-white border-0">• Sistema de presión constante y velocidad variable</ListGroup.Item>
                <ListGroup.Item className="bg-transparent text-white border-0">• Equipos de presión diferencial</ListGroup.Item>
                <ListGroup.Item className="bg-transparent text-white border-0">• Bombeo de pozo profundo y niveles freáticos</ListGroup.Item>
                <ListGroup.Item className="bg-transparent text-white border-0">• Sistemas eyector (niveles freáticos, aguas lluvias, aguas residuales, pozos sépticos, reutilización de aguas)</ListGroup.Item>
                <ListGroup.Item className="bg-transparent text-white border-0">• Sistemas de riego y drenaje (industria agropecuaria e industrial)</ListGroup.Item>
              </ListGroup>
            </Row>
          </Container>
        </div>
      </div>

      {/* Contenedor: Equipos Nacionales */}
      <div className="container my-5 d-flex justify-content-center">
        <Container className="p-4 text-white rounded shadow-sm">
          <h5 className="text-center mb-3 titulo-rojo">Equipos Nacionales</h5>
          <Row>
            <ListGroup variant="flush">
              <ListGroup.Item className="bg-transparent text-white border-0">• Instalación con altos estándares de calidad y cumplimiento de normas vigentes</ListGroup.Item>
              <ListGroup.Item className="bg-transparent text-white border-0">• Puesta en marcha de todo el suministro de equipos</ListGroup.Item>
              <ListGroup.Item className="bg-transparent text-white border-0">• Mantenimientos preventivos y correctivos</ListGroup.Item>
              <ListGroup.Item className="bg-transparent text-white border-0">• Asesorías técnicas, diseño y planimetría con personal altamente capacitado</ListGroup.Item>
            </ListGroup>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Queofrecemos;
